<template>
  <button :class="classes" class="v3-row-toggler">
    <i :class="active ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
  </button>
</template>

<script>
export default {
  name: "RowToggler",
  props: { classes: [Array, String], active: Boolean }
}
</script>
